/* eslint-disable react-hooks/exhaustive-deps */
import { lazy, Suspense, useEffect } from "react";
import "swiper/css";
/// Components
import { connect, useDispatch } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Index from "./jsx";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import "react-toastify/dist/ReactToastify.css";
import "./css/style.css";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./vendor/datatables/css/dataTables.min.css";
import ViewTribute from "./jsx/pages/ViewTribute";

const Login = lazy(() => import("./jsx/pages/Login"));
const Register = lazy(() => import("./jsx/pages/Register"));


function App(props) {
  console.log(props.isAuthenticated);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  console.log(props);
  useEffect(() => {
    checkAutoLogin(dispatch, navigate);
  }, [dispatch, location.pathname]);

  let routes = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register/:qrcode" element={<Register />} />
      <Route path="/tribute/profile/:id" element={<ViewTribute />} />
      <Route path="/" element={<Login />} />
      <Route path="/*" element={<Login />} />
    </Routes>
  );
  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routes}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default connect(mapStateToProps)(App);
